// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3kCLb","version":"Footer_version__3zZJ5","copyrightLabel":"Footer_copyrightLabel__1hBf7"};